import React, { useState, useEffect } from "react";
import { showToast } from "../../services/toastifyservices";
import { ToastContainer, toast } from "react-toastify";
import { Toaster } from "react-hot-toast";
import { Container, Form, Button, InputGroup } from "react-bootstrap";
import { IoPersonSharp } from "react-icons/io5";
import { FaLock } from "react-icons/fa6";
import { SignInSchema } from "../../schemas/index";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAuth } from "../../Redux-store/authSlice";
import { postaxiosRequest, postaxiosRequestWithToken } from "../../api/api";
import "./loginv2.css";
import { PiEyeDuotone,PiEyeSlashDuotone  } from "react-icons/pi";


const initialValues = {
    email: "",
    password: "",
    otp: "",
    newPassword: "",
    confirmPassword: "",
};

const LoginV2 = () => {



    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [forgotPassword, setForgotPassword] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [resetPassword, setResetPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const formik = useFormik({
        initialValues,
        validationSchema: SignInSchema,
        onSubmit: async (values) => {
            setLoading(true);
            try {
                const response = await postaxiosRequest("assistant_api/login", {
                    email: values.email,
                    password: values.password,
                });
                if (response.success) {
                    const { user, token } = response.data.data;
                    showToast("success", response.data.message);
                    localStorage.setItem("user", JSON.stringify(user));
                    localStorage.setItem("token", token);
                    dispatch(setAuth({ userId: user.id, role: user.role, token, isLoggedIn: true }));
                    navigate("/dashboard");
                }
            } catch (error) {
                 showToast("error", error.response?.data?.message || "Login failed");

            } finally {
                setLoading(false);
            }
        },
    });


    const handleForgotPassword = async () => {
        debugger
        const email = formik.values.email;
        if (!email) {
              showToast("error", "Please enter your email.");
            return;
        }
        setLoading(true);
        try {
            const response = await postaxiosRequest("forgot-password", {
                email: email,
            });
            if (response.success) {
                showToast("success", response.data.message);
                setOtpSent(true);
            } else {
                showToast("error", response.message);
            }
        } catch (error) {
             showToast("error", "Failed to send OTP.");
        } finally {
            setLoading(false);
        }
    };

    const handleOTPVerification = async () => {
        debugger
        const otp = formik.values.otp;
        if (!otp) {
            showToast("error", "Please enter the OTP.");
            return;
        }
        setLoading(true);
        try {
            const response = await postaxiosRequest("verify-otp", {
                email: formik.values.email,
                otp_code: formik.values.otp,
            });
            if (response.success) {
                const { user, token } = response.data.data;
                showToast("success", response.data.message);
                localStorage.setItem("user", JSON.stringify(user));
                localStorage.setItem("token", token);
                dispatch(
                    setAuth({ userId: user.id, role: user.role, token, isLoggedIn: true })
                );
                setResetPassword(true);
            }
        } catch (error) {
            console.log("error", error);
             showToast("error", "OTP verification failed.");

        } finally {
            setLoading(false);
        }
    };
    const handleResetPassword = async () => {
        if (formik.values.newPassword !== formik.values.confirmPassword) {
              showToast("error", "Passwords do not match.");
            return;
        }
        setLoading(true);
        try {
            const response = await postaxiosRequestWithToken("reset-password", {
                password: formik.values.newPassword,
                confirm_password: formik.values.confirmPassword,
            });
            if (response.success) {
                 showToast("success", response.message);
                navigate("/dashboard");
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container fluid className="vh-100">
            {/* Left Section */}
            <div className="left-section d-none d-lg-flex align-items-center justify-content-center">
                <div className="text-center">
                    <h1>Welcome Back!</h1>
                    <p>To keep connected with us, please login with your personal info</p>
                </div>
            </div>

            {/* Right Section */}
            <div className="right-section">
                <div className="login-box text-center">
                    <div className="logo-container">
                        <img src="/logo.png" alt="Logo" className="logo-img" />
                    </div>
                    <h3 className="text-center header-text">Sign in to your account</h3>

                    <Form onSubmit={formik.handleSubmit} className="custom-form">
                        {resetPassword ? (
                            <>
                                <Form.Group controlId="formNewPassword" className="mt-3">
                                    <Form.Label className="fw-bold">New Password</Form.Label>
                                    <InputGroup className="custom-input-group">
                                        <InputGroup.Text className="custom-input-icon">
                                            <FaLock />
                                        </InputGroup.Text>
                                        <Form.Control
                                            type="password"
                                            placeholder="New Password"
                                            className="custom-input-field"
                                            {...formik.getFieldProps("newPassword")}
                                        />
                                    </InputGroup>
                                </Form.Group>

                                <Form.Group controlId="formConfirmPassword" className="mt-3">
                                    <Form.Label className="fw-bold">Confirm Password</Form.Label>
                                    <InputGroup className="custom-input-group">
                                        <InputGroup.Text className="custom-input-icon">
                                            <FaLock />
                                        </InputGroup.Text>
                                        <Form.Control
                                            type="password"
                                            placeholder="Confirm Password"
                                            className="custom-input-field"
                                            {...formik.getFieldProps("confirmPassword")}
                                        />
                                    </InputGroup>
                                </Form.Group>

                                <Button
                                    variant="primary"
                                    className="w-100 mt-4 custom-btn"
                                    onClick={() => setLoading(!loading)}
                                    disabled={loading}
                                >
                                    {loading ? "Resetting..." : "Reset Password"}
                                </Button>
                            </>
                        ) : forgotPassword ? (
                            <>
                                <Form.Group controlId="formEmail" className="mt-3">
                                    <Form.Label className="fw-bold">Email</Form.Label>
                                    <InputGroup className="custom-input-group">
                                        <InputGroup.Text className="custom-input-icon">
                                            <IoPersonSharp />
                                        </InputGroup.Text>
                                        <Form.Control
                                            type="email"
                                            placeholder="Enter your email"
                                            className="custom-input-field"
                                            {...formik.getFieldProps("email")}
                                            disabled={otpSent}
                                        />
                                    </InputGroup>
                                    {formik.errors.email && formik.touched.email && (
                                        <p className="form-error">{formik.errors.email}</p>
                                    )}
                                </Form.Group>

                                {otpSent && (
                                    <Form.Group controlId="formOTP" className="mt-3">
                                        <Form.Label className="fw-bold">Enter OTP</Form.Label>
                                        <InputGroup className="custom-input-group">
                                            <InputGroup.Text className="custom-input-icon">
                                                <FaLock />
                                            </InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter OTP"
                                                className="custom-input-field"
                                                {...formik.getFieldProps("otp")}
                                            />
                                        </InputGroup>
                                    </Form.Group>
                                )}

                                <Button
                                    type="button"
                                    className="btnColor form-control mt-3"
                                    onClick={!otpSent ? handleForgotPassword : handleOTPVerification}
                                    disabled={loading}
                                >
                                    {loading ? (!otpSent ? "Sending OTP..." : "Verifying...") : (!otpSent ? "Send OTP" : "Verify OTP")}
                                </Button>

                            </>
                        ) : (
                            <>
                                <Form.Group controlId="formEmail" className="mt-3">
                                    <Form.Label className="fw-bold">Email</Form.Label>
                                    <InputGroup className="custom-input-group">
                                        <InputGroup.Text className="custom-input-icon">📧</InputGroup.Text>
                                        <Form.Control
                                            type="email"
                                            placeholder="Email"
                                            className="custom-input-field"
                                            {...formik.getFieldProps("email")}
                                        />
                                    </InputGroup>
                                    {formik.errors.email && formik.touched.email && (
                                        <p className="form-error">{formik.errors.email}</p>
                                    )}
                                </Form.Group>

                                <Form.Group controlId="formPassword" className="mt-3">
                                    <Form.Label className="fw-bold">Password</Form.Label>
                                    <InputGroup className="custom-input-group">
                                        <InputGroup.Text className="custom-input-icon">🔒</InputGroup.Text>
                                        <Form.Control
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Password"
                                            className="custom-input-field"
                                            {...formik.getFieldProps("password")}
                                        />
                                        <InputGroup.Text className="bg-transparent border-0 cursor-pointer ">
                                            {showPassword ? <PiEyeDuotone onClick={() => setShowPassword(!showPassword)} size={18} /> : <PiEyeSlashDuotone onClick={() => setShowPassword(!showPassword)} size={18} />}
                                        </InputGroup.Text>
                                    </InputGroup>
                                    {formik.errors.password && formik.touched.password && (
                                        <p className="form-error">{formik.errors.password}</p>
                                    )}
                                </Form.Group>

                                <Button
                                    variant="primary"
                                    className="w-100 mt-4 custom-btn"
                                    type="submit"
                                    disabled={loading}
                                >
                                    {loading ? "Signing in..." : "Sign In"}
                                </Button>

                                {/* <p
                                    className="text-center mt-2"
                                    style={{ cursor: "pointer", color: "blue" }}
                                    onClick={() => setForgotPassword(true)}
                                >
                                    Forgot Password?
                                </p> */}
                            </>
                        )}
                    </Form>
                </div>
            </div>
            );
            <Toaster position="top-right" reverseOrder={false} />
        </Container>
    );
};

export default LoginV2;
